import React from "react";
import { connect } from "react-redux";
import {
  Button,
  CssBaseline,
  TextField,
  Link,
  Grid,
  Divider,
  Paper,
  Typography,
  Container,
  withStyles,
  Box,
  Card,
  CardContent,
  FormControl,
  InputAdornment,
  SvgIcon,
} from "@material-ui/core";
import { Formik } from "formik";
import * as Yup from "yup";
import { Helmet } from "react-helmet";
import { PatientActions } from "../../redux/actions/PatientActions";
import { DocumentActions } from "../../redux/actions/DocumentAction";
import DocumentRecordList from './DocumentRecordList'
import { history } from "../helpers/History";

import Autocomplete from "@material-ui/lab/Autocomplete";
import { USER_ROLE } from "../security/UserRole";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import Checkbox from "@material-ui/core/Checkbox";
import Fab from "@material-ui/core/Fab";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundColor: "#fff",
    //padding: theme.spacing(2),
  },
  table: {
    marginTop: theme.spacing(2),
    // display: "flex",
    // flexDirection: "column",
    alignItems: "center",
    // transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundColor: "#fff",
    //padding: theme.spacing(2),
    minHeight:250
  },avatar: {
    margin: theme.spacing(3),
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  buttons: {
    display: "flex",
    justifyContent: "center",
  },
  button: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
});

class DocumentList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      patientId: (this.props.userRole === USER_ROLE.PATIENT) ? this.props.patientId  : "",
      isCancelled :false,
    };
  }

  componentDidMount() {

    if (!this.props.patientId) {
      this.props.getAllPatient();
    }else if(this.props.patientId.length > 0){
      this.props.getDocumentByPatientId(this.props.patientId);
    }
  }

  componentDidUpdate(prevProps){
    if(this.props.isCancelledSuccessfully && !this.state.isCancelled){
      this.setState({isCancelled:true});
      this.props.getDocumentByPatientId(this.state.patientId);
    }
    if(this.props.isCancelledSuccessfully !== this.state.isCancelled){
      this.setState({isCancelled:this.props.isCancelledSuccessfully});
    }

  }

  render() {
    const classes = this.props.classes;
    return (
      <>
        <Helmet>
          <title>RxRapidMad | Document</title>
        </Helmet>

        <Container component="main" fixed className={classes.main}>
          <CssBaseline />
          
              <form
                className={classes.form}
                noValidate
                name="form"
              >
                <Box display="flex" pb={1} mb={1}>
                  <Box flexGrow={1}>
                    <Typography
                      gutterBottom
                      variant="h4"
                      color="primary"
                      className={classes.typography}
                    >
                      {"Documents"}
                    </Typography>
                  </Box>
                </Box>
                {!this.props.patientId && (
                  <Box display="flex" p={1} bgcolor="background.paper">
                    <Box p={1} flexGrow={1}>
                      <Autocomplete
                        freeSolo
                        id="free-solo-2-demo"
                        disableClearable
                        options={this.props.allPatientList.map((option) => option)}
                        getOptionLabel={(option) => {
                          return (
                            (option.firstName ? option.firstName : "") +
                            " " +
                            (option.lastName ? option.lastName : "")
                          );
                        }}
                        onChange={(event, nextValue) => {
                          this.setState({ patientId: nextValue.id });
                          if(nextValue.id){
                            this.props.getDocumentByPatientId(nextValue.id);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Patient Name"
                            variant="outlined"
                            InputProps={{
                              ...params.InputProps,
                              type: "search",
                            }}
                          />
                        )}
                      />
                    </Box>
                  </Box>
                )}
                
              </form>
            

            
              
                <DocumentRecordList 
                  documentList={this.props.documentList}
                  cancelDocument={(id)=>{this.props.cancelDocument(id)}} ></DocumentRecordList>
              
            
          
        </Container>
      </>
    );
  }
}

function mapStateToProps(state) {
  const allPatientList = state.patient.all;
  const documentList = state.document.active;
  const userRole = state.authentication.user.userRole;
  const patientId = state.authentication.user.patientId;
  const isCancelledSuccessfully = state.document.isCancelledSuccessfully;
  // const allDocumentList = state.document.all;
  return { allPatientList,documentList ,userRole,patientId, isCancelledSuccessfully};
}

const mapDispatchToProps = (dispatch) => {
  return {
    getAllPatient: () => dispatch(PatientActions.getAllPatients()),
    getDocumentByPatientId: (id) => dispatch(DocumentActions.getActiveDocRequest(id)),
    
    cancelDocument: (id) => dispatch(DocumentActions.cancelRequest(id)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles, { withTheme: true })(DocumentList));
